import type { FC } from 'react';
import { useForm } from 'react-hook-form';
import type { BlockEditFormState } from '@ContractBuilder/modules/block-edit';
import { useBlockEditFormStore } from '@ContractBuilder/modules/block-edit';
import { useSchemaStore } from '@ContractBuilder/store';
import { useOnBlockEditSubmit } from '@features/inline-block-edit/hooks/use-on-block-edit-submit';
import { ArtificialCustomEvent, useCustomEventListener } from '@providers/events';
import { useVariationsTabs } from '@providers/variations-tabs';
import { isEndorsementViewPath } from '@utils/app-paths';

import { InlineBlockEdit } from '../views/InlineBlockEdit';

interface InlineBlockEditControllerProps {
  className?: string;
}

export const InlineBlockEditController: FC<InlineBlockEditControllerProps> = ({ className }) => {
  const { handleSubmit } = useForm<BlockEditFormState>();
  const { onSubmit, onSubmitAsNew } = useOnBlockEditSubmit();
  const { currentVariationIdx, variationsCount } = useVariationsTabs();
  const { schema } = useSchemaStore(({ schema }) => ({ schema }));
  const { formValues } = useBlockEditFormStore(({ formValues }) => ({ formValues }));
  const isEndorsementView = isEndorsementViewPath();

  useCustomEventListener(ArtificialCustomEvent.SubmitInlineBlockEdit, () => {
    const latestFormValues = useBlockEditFormStore.getState().formValues;

    if (latestFormValues) {
      return onSubmit(latestFormValues);
    }
  });

  useCustomEventListener(ArtificialCustomEvent.SubmitAsNewInlineBlockEdit, () => {
    const latestFormValues = useBlockEditFormStore.getState().formValues;

    if (latestFormValues) {
      return onSubmitAsNew(latestFormValues);
    }
  });

  return (
    <InlineBlockEdit
      className={className}
      currentVariationIdx={currentVariationIdx}
      formValues={formValues}
      hasVariations={variationsCount > 0}
      isEndorsementView={isEndorsementView}
      onSubmit={handleSubmit(onSubmit)}
      schema={schema}
    />
  );
};
